import React, { useEffect, useState } from "react";
import { useLocation, useParams} from "react-router-dom"

const Posts2 = () => {
  const [data, setData] = useState(""); // Store HTML response
  const {id} = useParams();
  
  const query = new URLSearchParams(useLocation().search);
  
    const lang = query.get("lang");
    const ID_Number = query.get("ID_Number");
    const CUBEST = query.get("CUBEST");
    
  const fetchData = async () => {
    try {
      const response = await fetch(        
        //"http://localhost:3001/qcheck_hisScore?lang=th&ID_Number=1100801172079&CUBEST=2/2567"
        `http://localhost:3001/qcheck_hisScore?lang=${lang}&ID_Number=${ID_Number}&CUBEST=${CUBEST}`
        
      );
      const result = await response.text(); // Convert response to text (HTML)
      setData(result); // Store HTML content in state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // Run only once when the component mounts

  return (    
    <div>
      <div dangerouslySetInnerHTML={{ __html: data }} /> {/* Render HTML response */}
    </div>
  );
};

export default Posts2;
